import { TrueUpResultDto } from '@clh/api-client';

type TrueUpResult = Pick<
    TrueUpResultDto,
    'facilityName' | 'stripeInvoiceId' | 'error'
>;

export function summarizeTrueUpResults(results: TrueUpResult[]): {
    message: string;
    failed: boolean;
} {
    const invoiced = results.filter((result) => result.stripeInvoiceId);
    const failures = results.filter((result) => result.error);

    if (!invoiced.length && !failures.length) {
        return {
            message: 'No facilities had uninvoiced shifts',
            failed: false,
        };
    }

    const parts: string[] = [];

    if (invoiced.length) {
        parts.push(
            `Trued up invoices for ${invoiced.length} ${
                invoiced.length === 1 ? 'facility' : 'facilities'
            }`
        );
    }

    if (failures.length) {
        parts.push(
            `Failed: ${failures
                .map((failure) => failure.facilityName)
                .join(', ')}`
        );
    }

    return { message: parts.join('. '), failed: failures.length > 0 };
}
